import { observer } from "mobx-react-lite";
import type { InputCandidate } from "../../../../../types/candidate";
import * as S from "./style";
import { Icon, Text } from "@smartsuite/react-ui/lib";
import { t } from "i18next";
import { useRootStore } from "../../../../../stores/hooks";
import { Colors } from "@smartsuite/types";

export const InputMissingEditor = observer<{
  input: InputCandidate;
  actionHash: string;
  onClickTrash?: (input: InputCandidate) => void;
}>(({ input, actionHash, onClickTrash }) => {
  const {
    automations: { loadingDynamicDescription },
  } = useRootStore();

  return actionHash !== "" && !loadingDynamicDescription ? (
    <S.StyledSection>
      <Icon
        size={"M"}
        name={"important-lined"}
        color={Colors.bRed}
        width={26}
        height={26}
      />
      <S.MessageContainer>
        <S.MessageItem>{t("input-missing-editor.unknown-field")}</S.MessageItem>
        <S.MessageItem>{t("input-missing-editor.message")}</S.MessageItem>
      </S.MessageContainer>

      <S.BtnContainer
        onClick={() => (onClickTrash ? onClickTrash(input) : null)}
      >
        <Text size="s">{t("input-missing-editor.buttton-title")}</Text>
      </S.BtnContainer>
    </S.StyledSection>
  ) : null;
});
